<script >
	
	let openShinny = false;

	// function goBackClicked() {
		
	// 	openShinny = !openShinny;

	// }


	function openCheeseShinnyWindow(){
		window.open("https://pif.esa.ipb.pt/shiny/artisanefood/prmodels/cheese/", "_blank");
	}

	function openSausageShinyWindow(){
		window.open("https://pif.esa.ipb.pt/shiny/artisanefood/prmodels/sausage/", "_blank");
	}

	function openCCharts(){
		window.open("https://pif.esa.ipb.pt/shiny/artisanefood/ccharts/", "_blank");
	}

</script>


<div class="ourModelsContainer" id="ourModelsContainer">

	{#if openShinny}

		<div class="frameControl">
			<div class="goBackBtn" on:click={goBackClicked}>
				➜
			</div>
		</div>
		<iframe 			
				class="shinnyApp" 
				src="https://ubarron.shinyapps.io/control_charts/?fbclid=IwAR1IhnOS7nLplXvwtZaxab3FbHQXFitxdiw9Z31z3EN-ilKVCfoIYJ788Fs" 
				title="Shinny App"
		/>
	
	{:else}
		<div class="ourModelsTitle">
			Our Models
		</div>


		<div class="ourModelsImg">
			<div 
				class="shinnyBtn" 
				on:click={openCheeseShinnyWindow}
			>
				Simulation Model for Cheese-Making Process
			</div>

			<div 
				class="shinnyBtn" 
				on:click={openSausageShinyWindow}
			>
				Simulation Model for Sausage-Making Process
			</div>

			<div 
				class="shinnyBtn" 
				on:click={openCCharts}
			>
				Control Charts
			</div>


		</div>

	{/if}
</div>




<style >




@media only screen and (min-width: 768px) {

	.ourModelsContainer{
		width: 100vw;
		height: 100vh;	
		background-color: white;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		scroll-snap-align: start;
	}

	.ourModelsTitle{
		width: 80%;
		height: 20%;
		background-color: transparent;
		background-repeat: no-repeat;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #EF9144;
		font-size: 5.208333333333333vw;
		font-weight: 900;
		text-transform: capitalize;
		margin-top: 5%;

	}

	.ourModelsImg{
		width: 95%;
		height:100%;
		margin-top: 10px;
		padding: 50px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: flex-start;
		/* justify-content: center; */
		gap:20px;
		background-color: transparent;
	}

	.shinnyBtn{
		width: 200px;
		height: 150px;
		padding: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #333333;
		font-style: normal;
		font-weight: 700;
		font-size: 1rem;
		border-radius: 10px;
		background-color:#ef9144c3;
		box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
		text-align: center;
		cursor:pointer;
	}

	.decisionTool{
		background-size:contain;
		background-repeat: no-repeat;
		background-position: center center;
		background-image: url('/img/shinny/decisionTool.png');
	}

	.shinnyBtn:hover{
		opacity: 0.9;
	}


	.goBackBtn{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 1%;
		transform: rotate(180deg);
		width: auto;
		height: 100%;
	}

	.frameControl{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 4%;
		width: 100%;
	}
	.shinnyApp{
		position: static;
		width: 100%;
		height: 95%;
		border: none;
	}
}

</style>

